import React from 'react';

const WebsiteList = ({ websites, onSelectSite, selectedId, isOpen, setIsOpen }) => {
  return (
    <div className={`bottom-panel ${isOpen ? 'open' : 'closed'}`}>
      <div className="panel-header" onClick={() => setIsOpen(!isOpen)}>
        <div className="header-left">
          <h3>EXPLORE NODES</h3>
          <span className="site-count">{websites.length} SITES</span>
        </div>
        <button className="toggle-btn">{isOpen ? '▼' : '▲'}</button>
      </div>
      
      {isOpen && (
        <div className="panel-content">
          {websites.length === 0 ? (
            <div className="no-results">No websites found</div>
          ) : (
            websites.map(site => (
              <div
                key={site.id}
                className={`site-item ${selectedId === site.id ? 'selected' : ''}`}
                onClick={() => onSelectSite(site)}
              >
                <span className="site-icon">{site.icon}</span>
                <div className="site-info">
                  <div className="site-name">{site.name}</div>
                  <div className="site-url">{site.url}</div>
                </div>
                <span className="site-category">{site.category}</span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default WebsiteList;